"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyClaimSchema = void 0;
var claim_relation_attachment_schema_1 = require("./claim-relation-attachment-schema");
var claim_schema_1 = require("./claim-schema");
var conveyancing_schema_1 = require("./conveyancing-schema");
var default_borrower_schema_1 = require("./default-borrower-schema");
var legacy_claim_remark_schema_1 = require("./legacy-claim-remark-schema");
var property_location_schema_1 = require("./property-location-schema");
exports.legacyClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcLoanAccountNumber',
        'approvedLenderID',
        'buildingTypeCode',
        'chattleMortgageIndicator',
        'claimAvoidanceActivityTypeCode',
        'costableUnitID',
        'dwellingTypeCode',
        'financialInstitutionID',
        'financialInstitutionTransitNumber',
        'lenderLoanAmount',
        'lenderLoanNumber',
        'loanAmortizationPeriod',
        'loanInterestRate',
        'loanTermPeriod',
        'mortgageInsuranceClaimsSystemEditIndicator',
        'mortgageLoanInsurancePremiumDueAmount',
        'nationalHousingActSectionNumber',
        'officeID',
        'originalApprovedLenderID',
        'propertyAcquisitionClassTypeCode',
        'propertyLendingValue',
        'recordCreatedComputerSubsystemID',
        'recordCreatedComputerSystemID',
        'recordCreatedDate',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'singleIndustryTownIndicator',
        'tenureTypeCode',
        'totalBedCount',
        'totalUnitCount',
    ],
    properties: {
        legacyClaimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        cmhcLoanAccountNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        applicationApprovedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        approvedLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        buildingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        chattleMortgageIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        claimAvoidanceActivityTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        corporateRecordFileDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        costableUnitID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        designatedTpLegalDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        dwellingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        fileDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        financialInstitutionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        financialInstitutionTransitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        lenderLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        lenderLoanNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        loanAmortizationPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        loanInterestRate: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        loanTermPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        mortgageInsuranceClaimsSystemEditIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        mortgageInsuranceClaimsSystemLaunchEditDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mortgageLoanInsurancePremiumDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        nationalHousingActSectionNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        officeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        originalApprovedLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyAcquisitionClassTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyLendingValue: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        recordCreatedComputerSubsystemID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        recordCreatedComputerSystemID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        recordCreatedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        revertCmhcLegalDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        singleIndustryTownIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        tenureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        totalBedCount: {
            type: 'number',
            maximum: 99999,
            minimum: -99999,
            multipleOf: 1,
            errorMessage: 'should be a decimal with up to 5 digits in total and 0 digits of precision',
        },
        totalUnitCount: {
            type: 'number',
            maximum: 9999,
            minimum: -9999,
            multipleOf: 1,
            errorMessage: 'should be a decimal with up to 4 digits in total and 0 digits of precision',
        },
        claim: claim_schema_1.claimSchema,
        claimRelationAttachments: {
            type: ['array', 'null'],
            items: claim_relation_attachment_schema_1.claimRelationAttachmentSchema,
        },
        conveyancing: conveyancing_schema_1.conveyancingSchema,
        defaultBorrowers: {
            type: ['array', 'null'],
            items: default_borrower_schema_1.defaultBorrowerSchema,
        },
        propertyLocation: property_location_schema_1.propertyLocationSchema,
        remarks: {
            type: ['array', 'null'],
            items: legacy_claim_remark_schema_1.legacyClaimRemarkSchema,
        },
    },
};
